import { textXs } from '@insify/design-system/typography';
import { PaymentElement } from '@stripe/react-stripe-js';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';

import { useStripePayment } from '../../../../../components/StripeProvider';

import styles from './CreditCard.module.css';

export const CreditCard = ({ className }: { className?: string }) => {
  const { paymentState, setPaymentState } = useStripePayment();
  const [isInvalid, setIsInvalid] = useState(false);

  useEffect(() => {
    return () => {
      setPaymentState?.({ state: 'idle' });
    };
  }, []);

  const handlePaymentElementChange = useCallback(() => {
    setIsInvalid(false);
  }, [setIsInvalid]);

  useEffect(() => {
    if (paymentState.state === 'error') {
      setIsInvalid(true);
    }
  }, [paymentState.state]);

  const showErrorMessage = paymentState.state === 'error' && isInvalid;

  return (
    <>
      <div className={clsx(styles.card, showErrorMessage && styles.error, className)}>
        {paymentState.state !== 'initializing' && <PaymentElement onChange={handlePaymentElementChange} />}
        {showErrorMessage && <span className={clsx(textXs, styles.errorMessage)}>{paymentState.data.message}</span>}
      </div>
    </>
  );
};
